import { API, graphqlOperation } from 'aws-amplify'
import { updatePartner } from './updatePartnerMutation'

export async function updatePartnerAppSettings({ id, app_settings }) {
  return API.graphql(
    graphqlOperation(updatePartner, {
      input: {
        id,
        app_settings
      }
    })
  )
}
